import { render, staticRenderFns } from "./BeaconData.vue?vue&type=template&id=64e21792&"
import script from "./BeaconData.vue?vue&type=script&lang=js&"
export * from "./BeaconData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports